CANDYRACK_DOCUMENT_LISTENER = true;

CANDYRACK_CAN_ATC = (btn) => {
    const form = document.querySelector("form.product-form")


    const isSelected = form.querySelector("img.uploadkit-thumbnail")
    
    return !!isSelected
}
